import React from 'react';
import Page from "../Page";
import ErrorBanner from "../../components/ErrorBanner";
import LoadingSpinner from "../../components/LoadingSpinner";
import Form from "../../components/form/Form";
import SVGIcon from "../../components/SVGIcon";
import FlipMove from "react-flip-move";
import EmptyBanner from "../../components/EmptyBanner";
import {Navigate} from "react-router-dom";


export default class SelectClientOrganization extends Page {

    static path = '/client/org/select-organization'

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isLoading: true,
            error: false,
            search: '',
            isSearching: false
        }
    }

    async componentDidMount()
    {
        super.componentDidMount();

        await TB.wait(500);
        let auth = TB.auth();
        let clients = auth?.user?.().allClientOrgs();

        if (!clients || !clients?.length) {
            return this.promisedState({
                error: {
                    title: 'No Client Organizations Found',
                    message: 'Please Contact Your Administrator',
                    onRetry: () => TB.auth().logout(),
                    retryText: 'Logout'
                },
                isLoading: false
            });
        } else if (clients && clients.length === 1) {
            return this.startClientSession(TB.first(clients));
        } else {
            clients = TB.orderBy(clients, 'name', 'asc')
            this.promisedState({
                isLoading: false,
                clients,
                suggestions: clients
            })
        }
    }

    async startClientSession(client) {
        await this.promisedState({isLoading: true})

        await TB.wait(500);
        let response = await TB.auth().startClientSession(client);

        if (!response) {
            return this.promisedState({
                error: {
                    title: 'Something Went Wrong',
                    message: 'Please Contact Your Administrator',
                    onRetry: () => TB.auth().logout(),
                    retryText: 'Logout'
                },
                isLoading: false
            });
        }
    }


    render() {

        let auth = this.context.auth;

        if (auth && auth.hasClientOrg()) {
            return <Navigate to={TB.auth().appropriate()} replace/>
        }

        let {
            isLoading,
            error,
            clients,
            suggestions,
            isSearching,
        } = this.state;

        return (
            <div className="client-select-container">

                {isLoading && <LoadingSpinner/>}

                {TB.isObject(error) && (
                    <ErrorBanner {...error}/>
                )}

                {!isLoading && !TB.isObject(error) && clients?.length > 0 && (

                    <div className="clients-session container">
                        <h3 className="client-session-header">
                            We found a few accounts connected to your email.
                            <span>
                                Please choose the one you want to log in with:
                            </span>
                        </h3>
                        <div className="form-search service-step">
                            <Form
                                ref="form"
                                submitButton={false}
                                model={{search: this.state.search}}
                                background={'none'}
                                onChange={async (model) => {
                                    await this.promisedState({isSearching: true})
                                    let suggestions = this.state.clients;

                                    const searched = (item) => {
                                        return (TB.isString(item) ? item : item?.name || '').trim()
                                            .toLowerCase()
                                            .indexOf(model.search.trim().toLowerCase());
                                    }

                                    if (model.search?.length) {
                                        suggestions = TB.orderBy(TB.filter([...this.state.clients], (item) => {
                                            return searched(item) > -1
                                        }), (item) => searched(item), 'desc');
                                    }
                                    this.promisedState({suggestions, search: model.search, isSearching: false})
                                }}
                                className={'select-client-form'}
                                fields={{
                                    search: {
                                        layout: 'elementOnly',
                                        required: false,
                                        placeholder: 'Filter..',
                                        label: false,
                                        addonBefore: <SVGIcon size={16} icon="search"/>
                                    }
                                }}/>
                        </div>
                        <div className='clients-list flex flex-row' style={{minHeight: 300}}>
                            <FlipMove typeName={null} maintainContainerHeight={false}>

                                {suggestions.length > 0 ? (
                                    suggestions.map(client => client?.id ? (
                                            <div key={client.name}
                                                 className="client-session-row lg:w-5/12 md:w-8/12 sm:w-full"
                                                 onClick={() => this.startClientSession(client)}
                                            >
                                                <img src={client.logo_path} alt={client.name}/>

                                                <div className="client-details">
                                                    <h2>{client.name}</h2>
                                                    <p>Created: {TB.moment(client.created_at).format('MMM D YYYY')}</p>
                                                    <p>Total Projects: {client.total_projects}</p>
                                                    <p className={client.is_registered ? 'text-success' : 'text-danger'}>
                                                        <i className={TB.mapClass("fas", {
                                                            'fa-check': client.is_registered,
                                                            'fa-times': !client.is_registered
                                                        })}/>
                                                        &nbsp; {client.is_registered ? 'Registered' : 'Not Registered'}
                                                    </p>
                                                </div>

                                            </div>
                                        ) : null
                                    )
                                ) : (
                                    <EmptyBanner key={"empty"} icon="fas fa-building"
                                                 message="No client organizations found. Try removing or editing your search"/>
                                )}
                            </FlipMove>
                        </div>
                    </div>

                )}
            </div>
        );
    }
}